import { c as _c } from "react/compiler-runtime";
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps } from './types';
export default function Tile6UpShoppable(t0) {
  const $ = _c(4);
  const {
    header,
    tiles,
    variant
  } = t0;
  let t1;
  if ($[0] !== header || $[1] !== tiles || $[2] !== variant) {
    t1 = <BuildContextProvider><SixTileCarousel className="tile6up-shoppable" alignText="center" data-testid="shoppable-component-test-id" header={header} tiles={tiles} variant={variant} overrideDefaultClass={true} /></BuildContextProvider>;
    $[0] = header;
    $[1] = tiles;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}